import { useState, useEffect, useCallback } from 'react';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import { setGlobalErrorHandler } from '../common/service-utils';

const GlobalErrorHandler = () => {
    const [error, setError] = useState(null);

    const handleError = useCallback((message) => {
        setError(message);
    }, []);

    useEffect(() => {
        setGlobalErrorHandler(handleError);
        return () => setGlobalErrorHandler(null);
    }, [handleError]);

    return (
        <Snackbar
            open={!!error}
            autoHideDuration={8000}
            onClose={() => setError(null)}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        >
            <Alert severity="error" variant="filled" onClose={() => setError(null)} sx={{ width: '100%' }}>
                {error}
            </Alert>
        </Snackbar>
    );
};

export default GlobalErrorHandler;
